import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useMemo } from 'react';
import { RatesApiAdapter } from '../adapters/RatesApiAdapter';
import { CreateRateItemRequest, RateItem } from '../models/rate.types';

interface AddRateItemParams {
  rateId: number;
  data: CreateRateItemRequest;
}

export const useAddRateItem = () => {
  const queryClient = useQueryClient();

  const adapter = useMemo(() => {
    const httpClient = createHttpClient(apiClientWH);
    return new RatesApiAdapter(httpClient);
  }, []);

  return useMutation<RateItem, Error, AddRateItemParams>({
    mutationFn: ({ rateId, data }: AddRateItemParams) =>
      adapter.addRateItem(rateId, data),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ['rate', variables.rateId] });
      queryClient.invalidateQueries({ queryKey: ['rates'] });
    },
  });
};
